import { tv } from 'tailwind-variants';

export const spinnerStyle = tv({
  slots: {
    base: 'relative inline-block',
    background:
      'absolute inset-0 block h-full w-full rounded-full border-[5px] border-solid opacity-25',
    foreground:
      'absolute inset-0 block h-full w-full animate-spin rounded-full border-[5px] border-solid border-transparent border-r-current'
  },
  variants: {
    theme: {
      light: {
        background: 'border-white'
      },
      dark: {
        background: 'border-primary'
      }
    }
  },
  defaultVariants: {
    theme: 'dark'
  }
});
